<template>
  <div class="legend-view smooth-shadow" v-if="legend && legend.length > 0">
    <LegendBar :legend="legend" :enableFilter="true" @applyFilter="setFilter" />
  </div>
</template>

<script>
import LegendBar from "@/components/global/views/LegendBar";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    title: String,
    legend: Array,
    type: String,
  },
  data() {
    return {
      cityName: "Mangaluru",
    };
  },
  computed: {
    ...mapGetters("Location", ["getActiveCity"]),
    getCityName() {
      if (this.getActiveCity && this.getActiveCity.name) {
        return this.getActiveCity.name;
      } else {
        return "All India";
      }
    },
  },
  components: {
    LegendBar,
  },
  methods: {
    ...mapActions("Map", ["setGridFilter"]),
    setFilter(filter) {
      try {
        this.setGridFilter({ ...filter, type: this.type });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-view {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 250px;
  background: var(--color-secondary);
  border: 1px solid var(--border-color);
  top: 12px;
  left: 12px;
  border-radius: 5px;
  padding: 10px 0 0 0;
  .legend {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    margin: 10px 10px;
    div {
      height: 10px;
    }
    p {
      padding: 3px 0;
      margin: 0;
      font-size: 0.8em;
      color: var(--font-color);
    }
  }
}
</style>
